import { defineComponent as _defineComponent } from 'vue'
import moment from 'moment';
import { ref } from 'vue';
import { request as axios } from '@/util/request';
import { getOrderList, initOrderData } from '@/api/order/order-management';
import { message } from 'ant-design-vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'PointsForRecord',
  props: {
    user_id: null
  },
  setup(__props: any) {

const props = __props as { user_id: string };

function dateFormat(time) {
  return moment(time * 1000).format('YYYY-MM-DD HH:mm:ss');
}


const dataSource = ref();
const pagination = ref<any>();
const knight_info = ref<any>();
const result = ref([
  {
    name: '配送状态',
    body: '不通过',
  },
  {
    name: '预计送达时间',
    body: 10,
  },
  {
    name: '取货码',
    body: '客诉扣款吧啦啦啦',
  },
  {
    name: '骑手姓名',
    body: 'fgajkfdjak',
  },
  {
    name: '联系电话',
    body: '2022-02',
  },
  {
    name: '佣金（元）',
    body: '2022-02',
  },
  {
    name: '抢单时间',
    body: '2022-02',
  },
  {
    name: '取货时间',
    body: '2022-02',
  },
  {
    name: '送达时间',
    body: '2022-02',
  },
]);
function handleChange(page: { current: number; pageSize: number; showTotal: any; total: number }) {
  query(page.current);
}
async function query(current: any) {
  const query_params = {
    pay_type: 4,
    user_id: props.user_id,
    current: current || 1,
  };
  const res: any = await getOrderList(query_params);

  if (res.status !== 200) {
    message.error(res.message);
    return;
  }
  const data = initOrderData(res.data);
  data.detail.forEach((item, index) => {
    data.detail[index] = {
      ...item,
      level: 0,
      children: [{ ...item, level: 1, id: '1-' + item.id }],
    };
  });
  dataSource.value = data.detail;
  pagination.value = {
    current: Number(data.current),
    total: Number(data.total),
    pageSize: Number(data.limit),
    showTotal: () => `共${data.total}条, 每页${data.limit}条`,
  };
}
async function knightInfo(record: any) {
  knight_info.value = true;
  const res = await axios.get(`/boss/knight/order/${record.knight_order.id}`);
  result.value[0].body = res.data.status == 6 ? '已送达' : '超时送达';
  result.value[1].body = moment(res.data.delivery_time * 1000).format('YYYY-MM-DD');
  result.value[2].body = res.data.pickup_code;
  result.value[3].body = res.data.knight_name;
  result.value[4].body = res.data.knight_mobile;
  result.value[5].body = res.data.knight_commission / 100;
  result.value[6].body = moment(res.data.grab_time * 1000).format('YYYY-MM-DD');
  result.value[7].body = moment(res.data.pickup_time * 1000).format('YYYY-MM-DD');
  result.value[8].body = moment(res.data.confirmed_time * 1000).format('YYYY-MM-DD');
}
query(1);

return { __sfc: true,dateFormat, props, dataSource, pagination, knight_info, result, handleChange, query, knightInfo }
}

})